
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/privateAppsPanel/components/appDescription/appDescription.scss.css.virtualfile';
        module.exports = {"content":"_content_1006j_1","container":"_container_1006j_4"};